import React from 'react';
import { INPUT_MAP } from './form.config';

import { FORM_KEYS } from './form.keys';

const flexStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const checkBoxStyle = {
  ...flexStyle,
  maxHeight: '6rem',
};

export const columns = [
  {
    title: (
      <div className="col-title">
        <span />
      </div>
    ),
    dataIndex: FORM_KEYS.DRAG.key,
    key: FORM_KEYS.DRAG.key,
    style: { ...checkBoxStyle, width: '3rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DRAG.key] },
  },

  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.TITLE.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.TITLE.key,
    key: FORM_KEYS.TITLE.key,
    formConfig: {
      ...INPUT_MAP[FORM_KEYS.TITLE.key],
      linkPopoverProps: {
        placement: 'rightTop',
        overlayClassName:
          'lifecycle-link-popover guiding-principle-link-adjust',
      },
    },
    style: { width: '25%', 'text-align': 'left', 'padding-left': '0.875rem' },
  },

  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.DES.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.DES.key,
    key: FORM_KEYS.DES.key,
    formConfig: {
      ...INPUT_MAP[FORM_KEYS.DES.key],
      linkPopoverProps: {
        placement: 'rightTop',
        overlayClassName:
          'lifecycle-link-popover guiding-principle-link-adjust',
      },
    },
    style: { flexShrink: 1, 'padding-left': '0.875rem' },
  },
  {
    dataIndex: FORM_KEYS.DELETE.key,
    key: FORM_KEYS.DELETE.key,
    style: {
      ...flexStyle,
      width: '2.25rem',
      padding: '0.625rem 0rem 0.625rem 0.625rem',
    },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DELETE.key] },

    //
  },
];

export const getDefaultRowData = (data = {}) => ({
  [FORM_KEYS.COLOR.key]: '',
  [FORM_KEYS.DISPLAY.key]: true,
  [FORM_KEYS.IFRAME.key]: false,
  ...data,
});
